
let locationIP = `192.168.10.43`; // 本地ip地址--陈洁钰//http://zcjsq.huangshi.gov.cn/common-api-test/
//let basicUrl = `http://zcjsq.huangshi.gov.cn/zst-api/`; // index.ts 请求地址
//let commonUrl = "http://zcjsq.huangshi.gov.cn/common-api/"; // index2.ts 请求地址
// let basicUrl = `https://huangshi.sic-credit.com/`; //  测试服 https://huangshi.sic-credit.com/
// let commonUrl = "https://huangshi.sic-credit.com/"; // index2.ts 请求地址
// let basicUrl = `http://192.168.3.110:8891/`; //  测试服 https://huangshi.sic-credit.com/
// let commonUrl = "http://192.168.3.110:8895/"; // index2.ts 请求地址
//let basicUrl = `http://10.249.250.109:9086/zst-api/`; //  测试服 https://huangshi.sic-credit.com/
//let commonUrl = "http://10.249.250.109:9086/common-api/"; // index2.ts 请求地址

// let basicUrl = `http://zcjsq.huangshi.gov.cn/door-server/`; //  测试服 https://huangshi.sic-credit.com/
// let commonUrl = "http://zcjsq.huangshi.gov.cn/door-server/"; // index2.ts 请求地址
//let basicUrl = `http://localhost:8088/`; //  测试服 https://huangshi.sic-credit.com/
//let commonUrl = "http://localhost:8088/"; // index2.ts 请求地址
let commonUrl = "/door-api/"; // 生产环境
let basicUrl = `/door-api/`; //  生产环境
let isKunMing =
  process.env.NODE_ENV === "development"
    ? location.hostname === locationIP
    : location.port === "12005";
isKunMing = false;
export default {
  // basicUrl: '',
  h5Url: "https://huangshi.sic-credit.com//H5/", // 测试https://huangshi.sic-credit.com//H5/  正式http://zcjsq.huangshi.gov.cn/H5/
  basicUrl,
  commonUrl,
  locationIP,
  version: "2021-09-01",
  isKunMing,
  reportRoot: process.env.NODE_ENV === "development" ? false : false,
  upImgBaseUrl: "https://yinchuan.sic-credit.com",
  basicPicUrl: "https://zst-shop.oss-cn-beijing.aliyuncs.com",
  // 短信验证码 addressCode
  msgAddressCode: "100000",
  // locationIP: `192.168.10.20`, // 本地ip地址
};
export const RouteConfig: any = {
  lightenList: ["/pcm/home", "/pcm/homePage", "/kunming/home"],
};
export const pageViewUnit = "人次";
export const FormValid: any = {
  name: (rule: any, value: any, callback: any) => {
    const reg = /^[\u4e00-\u9fa5\u3001\A-\Z\a-\z]+$/;
    if (value && !reg.test(value)) {
      callback(new Error(`请输入正确的姓名`));
    } else {
      callback();
    }
  },
  floatFloor1: (rule: any, value: any, callback: any) => {
    const reg = /^(0\.[0-9]+)$/;
    if (value && !reg.test(value)) {
      callback(new Error("请输入小于1的小数"));
    } else {
      callback();
    }
  },
  number: (rule: any, value: any, callback: any) => {
    const reg = /^\d+$/;

    if (!reg.test(value)) {
      callback(new Error("请输入数字"));
    } else {
      callback();
    }
  },
  password: (rule: any, value: any, callback: any) => {
    const reg = /^[a-zA-Z]{0}[a-zA-Z\d]{8,20}$/;
    if (!reg.test(value)) {
      callback(new Error("请输入8-20位数的密码"));
    } else {
      callback();
    }
  },
  email: (rule: any, value: any, callback: any) => {
    const reg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;

    if (!reg.test(value)) {
      callback(new Error("请输入正确的邮箱"));
    } else {
      callback();
    }
  },
  idCard: (rule: any, value: any, callback: any) => {
    const reg = /^(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;

    if (!reg.test(value)) {
      callback(new Error("请输入正确的身份证号"));
    } else {
      callback();
    }
  },
  socialIdCard: (rule: any, value: any, callback: any) => {
    const reg = /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/;

    if (!reg.test(value)) {
      callback(new Error("请输入正确的社会统一信用代码"));
    } else {
      callback();
    }
  },
  phone: (rule: any, value: any, callback: any) => {
    const reg = /^1[345789]\d{9}$/;
    if (!reg.test(value)) {
      callback(new Error("请输入11位手机号"));
    } else {
      callback();
    }
  },
  account: (rule: any, value: any, callback: any) => {
    const reg = /^[a-zA-Z]{0}[a-zA-Z\d]{6,10}$/;

    if (!reg.test(value)) {
      callback(new Error("请输入首字母英文的账号(6-10位)"));
    } else {
      callback();
    }
  },
  unit_name: (rule: any, value: any, callback: any) => {
    // 带括号
    const reg = /^[\u4E00-\u9FA5A-Za-z()（）]{2,40}$/;

    if (!reg.test(value)) {
      callback(new Error("请输入中英文的企业名称"));
    } else {
      callback();
    }
  },
};
export const TitleConfig: any = {
  title: "黄石政策计算器",
  kunmingTitle: "",
  subTitle: "",
  regist: {
    phone: {
      title: "使用手机号注册",
    },
    unit: {
      title: "",
    },
    person: {
      title: "",
    },
  },
};
export const TableConfig: any = {
  aside: {},
  navigation: {},
  lastProject_state: {},
  intelligent_recommendation: {
    title: "智能推荐",
    table: [
      {
        type: "index",
        label: "序号",
        width: "40px",
      },
      {
        label: "标题",
        width: "100px",
      },
      {
        label: "发文单位",
        width: "100px",
      },
      {
        label: "公示时间",
        width: "100px",
      },
    ],
  },
  information_publicity: {
    title: "信息公示",
    table: [
      {
        type: "index",
        label: "序号",
        width: "40px",
      },
      {
        label: "标题",
        width: "100px",
      },
      {
        label: "发文单位",
        width: "100px",
      },
      {
        label: "公示时间",
        width: "100px",
      },
    ],
  },
  self_project: {
    title: "我的项目",
    table: [
      {
        type: "index",
        label: "序号",
        width: "40px",
      },
      {
        label: "项目名称",
        width: "100px",
      },
      {
        label: "申请人",
        width: "100px",
      },
      {
        label: "金额",
        width: "100px",
      },
      {
        label: "项目状态",
        width: "100px",
      },
      {
        label: "申请时间",
        width: "100px",
      },
      {
        label: "操作",
        width: "100px",
      },
    ],
  },
};
export const SectionConfig: any = {
  policy: {
    title: "扶持政策",
    btns: [
      {
        value: "云南省",
        label: "云南省",
      },
    ],
    extra: {
      label: "更多",
      path: "/pcm/super",
    },
    jump: {
      path: "/pcm/policy/detail",
    },
  },
  hotProject: {
    title: "热门项目",
    extra: {
      label: "更多",
      path: "/pcm/apply",
    },
    jump: {
      path: "/pcm/policy/detail",
    },
  },
  hotInform: {
    title: "热门通知",
    extra: {
      label: "更多",
      path: "/pcm/inform",
    },
    jump: {
      path: "/pcm/inform/detail",
    },
  },
  news: {
    title: "最新咨询",
    jump: {
      label: "详情",
      path: "pcm/news/detail",
    },
  },
};
export const FormConfig: any = {
  yes_no: [
    {
      value: 0,
      label: "是",
    },
    {
      value: 1,
      label: "否",
    },
  ],
  industryDirection: [
    {
      value: "新一代信息技术",
      label: "新一代信息技术",
    },
    {
      value: "集成电路",
      label: "集成电路",
    },
    {
      value: "医疗健康",
      label: "医疗健康",
    },
    {
      value: "智能设备",
      label: "智能设备",
    },
    {
      value: "节能环保",
      label: "节能环保",
    },
    {
      value: "新能源智能汽车",
      label: "新能源智能汽车",
    },
    {
      value: "新材料",
      label: "新材料",
    },
    {
      value: "人工智能",
      label: "人工智能",
    },
    {
      value: "软件和信息服务业",
      label: "软件和信息服务业",
    },
  ],
  enterpriseOwnershi: [
    {
      value: "中关村企业园",
      label: "中关村企业园",
    },
    {
      value: "开发区企业",
      label: "开发区企业",
    },
    {
      value: "大专院校办企业",
      label: "大专院校办企业",
    },
    {
      value: "科研院所企业",
      label: "科研院所企业",
    },
    {
      value: "留学人员创办企业",
      label: "留学人员创办企业",
    },
    {
      value: "科研院所整体转制企业",
      label: "科研院所整体转制企业",
    },
    {
      value: "科技创新型企业",
      label: "科技创新型企业",
    },
    {
      value: "国家文创试验区企业",
      label: "国家文创试验区企业",
    },
  ],
  unit_nature: [
    {
      value: "国企",
      label: "国企",
    },
    {
      value: "民企",
      label: "民企",
    },
    {
      value: "外企",
      label: "外企",
    },
    {
      value: "其他",
      label: "其他",
    },
  ],
  unit_type: [
    {
      value: "事业单位",
      label: "事业单位",
    },
    {
      value: "全民所有制企业",
      label: "全民所有制企业",
    },
    {
      value: "其他",
      label: "其他",
    },
    {
      value: "内资企业",
      label: "内资企业",
    },
    {
      value: "农民专业合作社",
      label: "农民专业合作社",
    },
    {
      value: "合伙企业",
      label: "合伙企业",
    },
    {
      value: "合营企业",
      label: "合营企业",
    },
    {
      value: "国有企业",
      label: "国有企业",
    },
    {
      value: "外商投资企业",
      label: "外商投资企业",
    },
    {
      value: "外国（地区）企业",
      label: "外国（地区）企业",
    },
    {
      value: "有限责任公司",
      label: "有限责任公司",
    },
    {
      value: "法人独资企业",
      label: "法人独资企业",
    },
    {
      value: "社会团体",
      label: "社会团体",
    },
    {
      value: "私营企业",
      label: "私营企业",
    },
    {
      value: "联营企业",
      label: "联营企业",
    },
    {
      value: "股份合作企业",
      label: "股份合作企业",
    },
    {
      value: "股份有限公司",
      label: "股份有限公司",
    },
    {
      value: "自然人独资企业",
      label: "自然人独资企业",
    },
    {
      value: "集体所有制企业",
      label: "集体所有制企业",
    },
    {
      value: "非公司企业",
      label: "非公司企业",
    },
  ],
  industry: [
    {
      value: "农林牧副渔",
      label: "农林牧副渔",
    },
    {
      value: "制造业",
      label: "制造业",
    },
    {
      value: "采矿业",
      label: "采矿业",
    },
    {
      value: "电、煤气及水的生产供应业",
      label: "电、煤气及水的生产供应业",
    },
    {
      value: "供水，污水处理、废物管理和补救",
      label: "供水，污水处理、废物管理和补救",
    },
    {
      value: "建筑业",
      label: "建筑业",
    },
    {
      value: "批发和零售业",
      label: "批发和零售业",
    },
    {
      value: "交通运输、仓储和邮政业",
      label: "交通运输、仓储和邮政业",
    },
    {
      value: "住宿和餐饮业",
      label: "住宿和餐饮业",
    },
    {
      value: "信息传输、软件和信息技术服务业",
      label: "信息传输、软件和信息技术服务业",
    },
    {
      value: "金融业",
      label: "金融业",
    },
    {
      value: "房地产业",
      label: "房地产业",
    },
    {
      value: "租凭和商务服务业",
      label: "租凭和商务服务业",
    },
    {
      value: "科学研究和技术服务业",
      label: "科学研究和技术服务业",
    },
    {
      value: "水利、环境和公共设施管理业",
      label: "水利、环境和公共设施管理业",
    },
    {
      value: "居民服务、修理和其他服务业",
      label: "居民服务、修理和其他服务业",
    },
    {
      value: "教育",
      label: "教育",
    },
    {
      value: "卫生和社会工作",
      label: "卫生和社会工作",
    },
    {
      value: "文化、体育和娱乐",
      label: "文化、体育和娱乐",
    },
    {
      value: "公共管理、社会保障和社会组织",
      label: "公共管理、社会保障和社会组织",
    },
    {
      value: "国际组织",
      label: "国际组织",
    },
  ],
  industry2: [
    {
      value: "农、林、牧、渔业",
      label: "农、林、牧、渔业",
    },
    {
      value: "工业",
      label: "工业",
    },
    {
      value: "建筑业",
      label: "建筑业",
    },
    {
      value: "批发业",
      label: "批发业",
    },
    {
      value: "零售页",
      label: "零售业",
    },
    {
      value: "交通运输业",
      label: "交通运输业",
    },
    {
      value: "仓储业",
      label: "仓储业",
    },
    {
      value: "邮政业",
      label: "邮政业",
    },
    {
      value: "住宿业",
      label: "住宿业",
    },
    {
      value: "餐饮业",
      label: "餐饮业",
    },
    {
      value: "信息传输业",
      label: "信息传输业",
    },
    {
      value: "软件和信息服务业",
      label: "软件和信息服务业",
    },
    {
      value: "房地产开发经营",
      label: "房地产开发经营",
    },
    {
      value: "物业管理",
      label: "物业管理",
    },
    {
      value: "租凭和商务服务业",
      label: "租凭和商务服务业",
    },
    {
      value: "其他未列明行业",
      label: "其他未列明行业",
    },
  ],
  tech_field: [],
  price_type: [
    {
      label: "元",
      value: "元",
    },
  ],
  login_radio_type: [
    // {
    //   label: '个人账号登录',
    //   value: 'person',
    // },
    // {
    //   label: '企业账号登录',
    //   value: 'unit',
    // },
    {
      label: "密码登录",
      value: "unit",
    },
    {
      label: "验证码登录",
      value: "code",
    },
  ],
  regist_radio_type: [
    {
      label: "个人账号注册",
      value: "person",
    },
    {
      label: "企业账号注册",
      value: "unit",
    },
  ],
};
